export { FastshiftTableSearch } from './fastshift-table-search';
